import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from '@reduxjs/toolkit';
import selectAreaReducer from './area';
import selectBeesReducer from './bees';
import selectPlantsReducer from './plants';
import floweringArchReducer from './floweringArch';
import genericErrorReducer from './genericError';
import sessionReducer from './session';

const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  area: selectAreaReducer,
  bees: selectBeesReducer,
  plants: selectPlantsReducer,
  floweringArch: floweringArchReducer,
  genericError: genericErrorReducer,
  session: sessionReducer,
});

export const history = createBrowserHistory();

const middleware = [...getDefaultMiddleware({ immutableCheck: false }), routerMiddleware(history)];

const store = configureStore({
  reducer: createRootReducer(history),
  middleware,
});

export default store;
